import { Box, Skeleton, Stack, useTheme } from "@mui/material";
import { UserFeedbackListItemSkeleton } from "./UserFeedbackListItemSkeleton";

const UserFeedbackListSkeleton = () => {
  const theme = useTheme();

  return (
    <Stack spacing={0.5} sx={{ p: 0.5 }}>
      <Box sx={{ pl: 0.5 }}>
        <Skeleton variant="text" width={100} height={28} />
      </Box>
      <Box sx={{ backgroundColor: theme.palette.grey[100], borderRadius: 1 }}>
        <Skeleton variant="text" width={30} height={24} sx={{ m: 0.5 }} />
        <Stack spacing={0.5} sx={{ px: 0.5, pb: 0.5 }}>
          <UserFeedbackListItemSkeleton />
          <UserFeedbackListItemSkeleton />
          <UserFeedbackListItemSkeleton />
        </Stack>
      </Box>
    </Stack>
  );
};

export { UserFeedbackListSkeleton };
